<script setup lang="ts">
import Audience from '@/components/audiences/Audience.vue'
import AudiencePreview from '@/components/audiences/AudiencePreview.vue'

import type { SelectedAudience } from '@/components/audiences/Audience.vue'

const count = defineModel<number>('count')
const isLoadingCount = defineModel<boolean>('isLoadingCount')
const step = defineModel<number>('step')
const name = defineModel<string>('name')
const selectedAudience = defineModel<SelectedAudience>('selectedAudience')

defineProps<{
  userStoresAudience: number
  userStoresCount: number
}>()

const { t } = useI18n()
</script>

<template>
  <div class="flex w-full flex-col gap-6 pb-6 xl:grid xl:grid-cols-12 px-12">
    <section class="flex flex-col gap-6 col-span-8">
      <div class="rounded-md border bg-white">
        <div class="flex flex-col gap-4 p-6">
          <fieldset class="flex flex-col gap-2">
            <AppFormInput
              id="name"
              v-model="name"
              required
              :label="t('pages.campaignEmail.create.inputName')"
              :placeholder="t('pages.campaignEmail.create.inputNamePlaceholder')"
            />
          </fieldset>
        </div>
      </div>

      <Audience
        ref="audience"
        v-model="selectedAudience"
        v-model:count="count"
        v-model:is-loading-count="isLoadingCount"
        type="email"
      />
    </section>

    <section class="flex flex-col gap-6 col-span-4">
      <AudiencePreview
        class="sticky top-2"
        :rules="{}"
        :targets-count="count"
        :selected-audience="selectedAudience"
        :stores-contacts-count="userStoresAudience"
        :stores-count="userStoresCount"
        :loading="isLoadingCount"
      >
        <template #title>
          <div class="flex items-center justify-between">
            <p class="text-base font-semibold text-foreground">
              {{ t('pages.campaignEmail.create.preview.title') }}
            </p>
            <Button variant="default-primary" :disabled="name.length === 0 || count === 0" @click="step = step + 1">
              {{ t('pages.campaignEmail.create.preview.buttons') }}
            </Button>
          </div>
        </template>
      </AudiencePreview>
    </section>
  </div>
</template>
